import {LitElement, html, css, svg} from 'lit';
import {customElement, property} from 'lit/decorators.js';

@customElement('obi-object-lagan')
export class ObiObjectLagan extends LitElement {
  @property({type: Boolean}) useCssColor = false;

  private icon = svg`<svg width="24" height="24" viewBox="0 0 24 24" fill="currentColor" xmlns="http://www.w3.org/2000/svg">
<path fill-rule="evenodd" clip-rule="evenodd" d="M13 10H11V12.3208L7.03648 11.2588C6.50301 11.1159 5.95469 11.4324 5.81174 11.9659L4.25882 17.7615C4.11588 18.295 4.43247 18.8433 4.96593 18.9862L16.557 22.0921C17.0905 22.235 17.6388 21.9184 17.7818 21.3849L19.3347 15.5894C19.4776 15.0559 19.1611 14.5076 18.6276 14.3646L13 12.8567V10ZM7.48477 13.4495L6.44949 17.3132L8.38135 17.8308L9.41662 13.9671L7.48477 13.4495ZM12.245 18.8661L10.3132 18.3485L11.3485 14.4848L13.2803 15.0024L12.245 18.8661ZM14.1769 19.3837L16.1088 19.9014L17.144 16.0377L15.2122 15.52L14.1769 19.3837Z" fill="currentColor"/>
<path d="M11 2H16V5H13V7.06215C14.2894 7.61385 15.7199 7.61261 17.0086 7.05844C17.3086 6.92924 17.9994 6.50733 17.9994 6.50733C17.9994 6.50733 18.6879 6.93533 18.9878 7.06453C19.6348 7.35018 20.3196 7.5 21 7.5H22V9H21C19.97 9 18.94 8.75 18 8.25C16.11 9.25 13.89 9.25 12 8.25C10.11 9.25 7.89 9.25 6 8.25C5.05 8.75 4.03 9 3 9H2V7.5H3C3.68364 7.5 4.36195 7.34876 5.01151 7.06049C5.31146 6.93129 6 6.5 6 6.5C6 6.5 6.6857 6.92801 6.98565 7.05721C8.27588 7.61383 9.70872 7.61467 11 7.06215V2Z" fill="currentColor"/>
</svg>
`;

  private iconCss = svg`<svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
<path fill-rule="evenodd" clip-rule="evenodd" d="M13 10H11V12.3208L7.03648 11.2588C6.50301 11.1159 5.95469 11.4324 5.81174 11.9659L4.25882 17.7615C4.11588 18.295 4.43247 18.8433 4.96593 18.9862L16.557 22.0921C17.0905 22.235 17.6388 21.9184 17.7818 21.3849L19.3347 15.5894C19.4776 15.0559 19.1611 14.5076 18.6276 14.3646L13 12.8567V10ZM7.48477 13.4495L6.44949 17.3132L8.38135 17.8308L9.41662 13.9671L7.48477 13.4495ZM12.245 18.8661L10.3132 18.3485L11.3485 14.4848L13.2803 15.0024L12.245 18.8661ZM14.1769 19.3837L16.1088 19.9014L17.144 16.0377L15.2122 15.52L14.1769 19.3837Z" style="fill: var(--element-active-color)"/>
<path d="M11 2H16V5H13V7.06215C14.2894 7.61385 15.7199 7.61261 17.0086 7.05844C17.3086 6.92924 17.9994 6.50733 17.9994 6.50733C17.9994 6.50733 18.6879 6.93533 18.9878 7.06453C19.6348 7.35018 20.3196 7.5 21 7.5H22V9H21C19.97 9 18.94 8.75 18 8.25C16.11 9.25 13.89 9.25 12 8.25C10.11 9.25 7.89 9.25 6 8.25C5.05 8.75 4.03 9 3 9H2V7.5H3C3.68364 7.5 4.36195 7.34876 5.01151 7.06049C5.31146 6.93129 6 6.5 6 6.5C6 6.5 6.6857 6.92801 6.98565 7.05721C8.27588 7.61383 9.70872 7.61467 11 7.06215V2Z" style="fill: var(--element-active-color)"/>
</svg>
`;

  override render() {
    return html`
      <div class="wrapper">${this.useCssColor ? this.iconCss : this.icon}</div>
    `;
  }

  static override styles = css`
    .wrapper {
      height: 100%;
      width: 100%;
      line-height: 0;
    }
    .wrapper > * {
      height: 100%;
      width: 100%;
    }
  `;
}

declare global {
  interface HTMLElementTagNameMap {
    'obi-object-lagan': ObiObjectLagan;
  }
}
